import React, { useEffect, useState } from 'react';
import { routePaths } from 'router';
import { useGetManyExpenses } from 'api/expenses/use-get-many-expenses.ts';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useExpensesFiltersStore } from 'shared/stores/use-expenses-filters.ts';
import { HighlightText } from 'components/common/highlight-text';
import { SearchFilter } from 'components/common/search-filter';

export const ExpensesSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useExpensesFiltersStore();
  const { moveToPath } = useMoveToPath();

  const { data: expenses, isError } = useGetManyExpenses({
    limit: 10,
    isHints: true,
    search: searchString,
    isSkip: !searchString,
  });

  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);

  useEffect(() => {
    if (expenses && !isError) {
      const values = expenses.data.map((expense) => ({
        label: (
          <>
            <HighlightText highlight={searchString} strong>
              {`#${expense.id}`}
            </HighlightText>
            {expense.clientNumber ? (
              <HighlightText highlight={searchString} type='secondary'>
                {` ${expense.clientNumber}`}
              </HighlightText>
            ) : null}
          </>
        ),
        value: expense.id,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [expenses, isError, searchString]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.expense, { expenseId: value });
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
